import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Loading from "../../../main/components/Loading";
import { clientsApi } from "../../../services/api";
import { Client } from "../types";
import { EditIconButton } from "../../../main/components/EditIconButton";
import ClientDetailsBodyPage from "../components/ClientDetailsBodyPage";
import ClientDetailsFooterPage from "../components/ClientDetailsFooterPage";
import ClientDetailsHeaderPage from "../components/ClientDetailsHeaderPage";
import EmptyStateNotFound from "../components/EmptyState";

export default function ClientDetails() {
  const [client, setClient] = useState<Client | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    onMount();
  }, []);

  const path = window.location.pathname;
  const clientId = path.split("/")[2];

  const onMount = async () => {
    setLoading(true);
    try {
      const clientResponse = await clientsApi.getClient(clientId);
      setClient(clientResponse);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Grid
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: loading ? "center" : "start",
        width: "100%",
        height: "100%",
        padding: { sm: "5px", xs: "10px" },
        rowGap: "20px",
      }}
    >
      {loading ? (
        <>
          <Loading />
        </>
      ) : (
        <>
          {client ? (
            <Grid
              container
              padding={{
                xs: "10px",
                sm: "10px",
              }}
            >
              <Grid
                item
                xs={12}
                sx={{
                  paddingBottom: "8px",
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <ClientDetailsHeaderPage client={client} />
              </Grid>

              <Grid item xs={12}>
                <ClientDetailsBodyPage client={client} onMount={onMount} />
              </Grid>
              <Grid item xs={12}>
                <ClientDetailsFooterPage client={client} />
              </Grid>
            </Grid>
          ) : (
            <EmptyStateNotFound />
          )}
        </>
      )}
    </Grid>
  );
}

type ClientInfoProps = {
  title: string;
  value?: string | null;
  paddingLeft?: boolean;
  onClickEditIcon?: () => void;
  tooltipTextEditButton?: string;
  valueWidth?: number | string;
  removePaddingInMobile?: boolean;
  onChange?: (value: string) => void;
  type?: string;
  justifyContent?: string;
};

export function ClientInfo(props: ClientInfoProps) {
  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: props.justifyContent
            ? props.justifyContent
            : "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            justifyContent: "center",
            paddingLeft: {
              xs:
                !props.removePaddingInMobile && props.paddingLeft
                  ? "35px"
                  : "0px",
              sm: "0px",
            },
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "0.8rem",
            }}
          >
            {props.title}
          </Typography>

          <Typography
            sx={{
              fontSize: "0.9rem",
              width: props.valueWidth,
              textAlign: "left",
            }}
          >
            {props.value ?? "Não informado"}
          </Typography>
        </Box>
        <Box>
          {props.onClickEditIcon && (
            <Box>
              <EditIconButton
                tooltipText={props.tooltipTextEditButton}
                onClick={props.onClickEditIcon}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Grid>
  );
}
